import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=383dbb4f&"
import script from "./TheFooter.vue?vue&type=script&lang=js&"
export * from "./TheFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheFooter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383dbb4f')) {
      api.createRecord('383dbb4f', component.options)
    } else {
      api.reload('383dbb4f', component.options)
    }
    module.hot.accept("./TheFooter.vue?vue&type=template&id=383dbb4f&", function () {
      api.rerender('383dbb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/betsur/modules/components/layout/TheFooter.vue"
export default component.exports